<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div :id="id">
    <div id="popup" class="ol-popup" v-show="showOw">
      <div class="popup_title">
        <span class="popup_title--prefix"></span>
        <span class="popup_title--content">详情</span>
        <img src="@/assets/myImg/1/icon-close.png" class="popup_title--sufix" id="popup-closer" @click="closeOverLay" />
      </div>
      <div id="popup-content">
        <div id="popup-content-page">
          <ul style="padding: 0px 10px">
            <li v-for="(item, index) in popupObject" :key="index"
              style="padding-top: 8px; font-family: MicrosoftYaHei; font-size: 13px; color: #ffffff; font-weight: 400">
              <span style="font-family: MicrosoftYaHei; font-size: 13px; color: #ffffff; font-weight: 400">
                {{ item[0] }}</span>:
              <span>{{ item[1] }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="lengend">
      <div class="layers">
        <div class="layer" v-for="item in layers" :key="item.id" @click="clickLabel(item)">
          <span class="layer-prefix">
            <img :src="item.icon" class="prefix_dp_icon" />
          </span>
          <span class="layer-content">
            <a-tooltip>
              <template slot="title">{{ item.name }}</template>
              {{ item.name.substring(0, 8) }}
            </a-tooltip>
          </span>
          <img class="layer-sufix" src="@/assets/myImg/1/icon-choose.png" v-show="item.load" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import Circle from 'ol/style/Circle'
import Fill from 'ol/style/Fill'
import Icon from 'ol/style/Icon'
import XYZ from 'ol/source/XYZ'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
import * as olProj from 'ol/proj'
import { defaults } from 'ol/interaction'
import LineString from 'ol/geom/LineString'
import { getUUID } from '@/utils/util'
import Feature from 'ol/Feature'
import rbush from 'rbush'
import { geoserverWFS, getMeterHistory } from '@/api/manage'

import MoveLine from './moveLine'
const x = 0
const y = 0
let map = null
export default {
  data () {
    return {
      id: getUUID(),
      showOw: false,
      popupObject: [],
      layers: [
        {
          icon:
            'https://linkeda-resource2.oss-cn-shenzhen.aliyuncs.com/smart-water/file/resource/2021-09-08/9cd1269db86a402ba8402ce7a19fbc38.png',
          id: 'index_map_remote_water_meter',
          name: '流量计',
          load: true
        },
        {
          icon:
            'https://linkeda-resource2.oss-cn-shenzhen.aliyuncs.com/smart-water/file/resource/2021-09-06/e92a3535b55c419b871e4df27075ec5a.png',
          id: 'index_map_piezometer2',
          name: '压力表',
          load: false
        },
        {
          icon:
            'https://linkeda-resource2.oss-cn-shenzhen.aliyuncs.com/smart-water/file/resource/2021-11-02/52acbc32db594386b57341541a08760c.jpg',
          id: 'water_factory_area',
          name: '水厂范围',
          load: true
        }
      ]
    }
  },
  mounted () {
    this.intiMap()
    console.log('addWMS====')
    this.addWMS(
      'smart_water:large_screen_zone_metering',
      `is_deleted = false and level = 3 and tenant_id = '${this.$store.state.user.info.tenantId}'`
    )
    this.addWMS(
      'smart_water:index_map_piezometer2',
      `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}'`,
      'index_map_piezometer2',
      false
    )
    this.addWMS(
      'smart_water:index_map_remote_water_meter',
      `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}'`,
      'index_map_remote_water_meter',
      true
    )
    this.addWMS(
      'smart_water:water_factory_area',
      `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}'`,
      'water_factory_area',
      true
    )
  },
  methods: {
    interpolation (start, end) {
      var points = []
      var x_u = (end[0] - start[0]) / 50
      var y_u = (end[1] - start[1]) / 50
      for (var i = 0; i < 50; i++) {
        points.push([start[0] + i * x_u, start[1] + i * y_u])
      }
      return points
    },
    clickLabel (item) {
      const thisName = item.id
      const allLayers = map.getLayers()
      console.log('allLayers===', allLayers)
      allLayers.array_.forEach(items => {
        if (thisName === items.values_.name) {
          items.setVisible(!items.values_.visible)
          const filterIndex = this.layers.findIndex(layer => {
            return layer.id === thisName
          })
          this.$set(this.layers, filterIndex, { ...item, load: items.values_.visible })
          console.log(this.layers, filterIndex, { ...item, load: items.values_.visible })
        }
      })
    },
    intiMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      const arr = this.$store.state.user.info.tenant.point
      console.log('arr', arr)
      map = new Map({
        view: new View({
          center: arr || [113.69899998770235, 25.5687667784428], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 12.6, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        controls: defaults({
          zoom: false // 隐藏+ - 按钮
        }),
        target: this.id // 地图容器id
      })
      const roadlayer = new TileLayer({
        name: '底图',
        title: '大屏数据',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          url: 'https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}'
        })
      })
      // map.render();
      //map.addLayer(roadlayer)
    },

    addWMS (name, cql, layerName, load = true) {
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params: { LAYERS: name, FORMAT: 'image/png', CQL_FILTER: cql },
        serverType: 'geoserver',
        url: `/api/geoserver/smart_water/wms`
      })
      const wmsLayer = new ImageLayer({
        name: layerName || 'large_screen_layer',
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 9999
      })
      wmsLayer.setVisible(load)
      map.addLayer(wmsLayer)
      // 压力表
      if (layerName === 'index_map_piezometer2') {
        this.clickWMS(wmsSource, 'index_map_piezometer2', wmsLayer)
      }
      // 流量计
      if (layerName === 'index_map_remote_water_meter') {
        this.clickWMS(wmsSource, 'index_map_remote_water_meter', wmsLayer)
      }
      // 水厂范围
      if (layerName === 'water_factory_area') {
        this.clickWMS(wmsSource, 'water_factory_area', wmsLayer)
      }
    },
    clickWMS (wmsSource, layerName, wmsLayer) {
      const that = this
      map.on('click', function (e) {
        console.log('click=====blueMap.vue')
        const url = wmsSource.getFeatureInfoUrl(e.coordinate, map.getView().getResolution(), 'EPSG:4326', {
          INFO_FORMAT: 'application/json'
        })
        // 判断是否有要素，一般wms返回的是false没有要素，所以wms的功能代码在else里
        if (map.hasFeatureAtPixel(e.coordinate)) {
          if (url) {
            fetch(url)
              .then(response => {
                return response.json()
              })
              .then(data => { })
          }
        } else {
          if (url) {
            fetch(url)
              .then(response => {
                return response.json()
              })
              .then(data => {
                if (data.features.length !== 0) {
                  if (wmsLayer.values_.visible) {
                    const properties = data.features[0].properties
                    that.addOverLay(e.coordinate, layerName, properties)
                  }
                }
              })
          }
        }
      })
    },
    addOverLay (coordinates, id, object) {
      this.closeOverLay()
      console.log(id, '123456')
      console.log(object)
      if (id === 'index_map_piezometer2') {
        // eslint-disable-next-line camelcase
        const { flow_num, install_address, piezometer_no, status } = object
        let statusVal = '正常'
        if (status === 2) {
          statusVal = '高压(' + object.high_pressure_value + ' Mpa)'
        } else if (status === 3) {
          statusVal = '低压(' + object.low_pressure_value + ')'
        } else if (status === 4) {
          statusVal = '采集异常'
        }
        this.popupObject = [
          ['名称', '压力表'],
          // eslint-disable-next-line camelcase
          ['安装地址', install_address],
          // eslint-disable-next-line camelcase
          ['表身号', piezometer_no],
          ['状态', statusVal],
          // eslint-disable-next-line camelcase
          ['压力值', flow_num + 'Mpa']
        ]
        this.showOw = true
      }
      if (id === 'index_map_remote_water_meter') {
        // eslint-disable-next-line camelcase
        const { diameter, address, appearance_no, flow_rate, forward_flow, reverse_flow } = object
        const cqls = { flowMeterNo: appearance_no }
        getMeterHistory(cqls)
          .then(res => {
            this.popupObject = [
              ['名称', '分区流量计'],
              ['安装地址', address],
              // eslint-disable-next-line camelcase
              ['表身号', appearance_no],
              ['口径', diameter],
              // eslint-disable-next-line camelcase
              ['瞬时流量', flow_rate],
              ['累积流量', res.data]
            ]
            this.showOw = true
          })
          .catch(e => {
            console.log(e)
          })
      }
    },

    closeOverLay () {
      this.popupObject = []
      this.showOw = false
    }
  }
}
</script>

<style lang="less" scoped>
#map {
  width: 100%;
  height: 100%;
  position: absolute;
}

.lengend {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  bottom: 24px;
  right: 24px;
  z-index: 5;
  width: 160px;

  .layers {
    width: 100%;
    max-height: 380px;
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 3px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(0, 32, 54, 0.75);
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 3px;
      background: rgba(0, 32, 54, 0.75);
    }

    .layer {
      color: #ffffff;
      width: 160px;
      height: 32px;
      background: rgba(255, 255, 255, 0.11);
      border-radius: 3px;
      margin: 0 auto 5px;
      display: flex;
      align-items: center;

      .layer-prefix {
        height: 22px;

        .prefix_dp_icon {
          height: 100%;
          width: 20px;
          margin-left: 12px;
          margin-right: 12px;
        }
      }

      .layer-content {
        width: 100%;
        flex: 1;
      }

      .layer-sufix {
        margin-left: 12px;
        margin-right: 12px;
        height: 12px;
        width: 12px;
      }
    }
  }

  .lengend_title {
    background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    display: flex;
    height: 36px;
    align-items: center;
    color: #ffffff;
    margin-bottom: 9px;

    .legend_title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .legend_title--content {
      width: 100%;
      flex: 1;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #ffffff;
      font-weight: 600;
      line-height: 12px;
      height: 12px;
    }

    .legend_title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }
}

.ol-popup {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border: 1px solid #cccccc;
  z-index: 999999;
  top: 12px;
  right: 12px;
  width: 160px;

  .popup_title {
    display: flex;
    height: 20px;
    align-items: center;
    background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    margin-bottom: 9px;

    .popup_title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .popup_title--content {
      font-family: MicrosoftYaHei;
      font-size: 13px;
      color: #ffffff;
      font-weight: 400;
      width: 100%;
      flex: 1;
      line-height: 12px;
      height: 12px;
    }

    .popup_title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }
}
</style>
